import React from 'react';
import PropTypes from 'prop-types';

import {
    ButtonGroup,
    Button,
} from '@zillow/constellation';

export default class InquiryInAction extends React.Component {
    static propTypes = {
        onSelectAction: PropTypes.func.isRequired,
    };

    constructor() {
        super();
        this.handleOnClickCall = this.handleOnClick.bind(this, 'call');
        this.handleOnClickSMS = this.handleOnClick.bind(this, 'sms');
    }

    handleOnClick(action) {
        const { onSelectAction } = this.props;

        onSelectAction(action);
    }

    render() {
        return (
            <ButtonGroup aria-label="contact controls">
                <Button onClick={this.handleOnClickCall} buttonType="secondary">
                    Call
                </Button>
                <Button onClick={this.handleOnClickSMS} buttonType="secondary">
                    SMS
                </Button>
            </ButtonGroup>
        );
    }
}
